import React from "react";

const SvgBackground = (props) => {
  const { className, style, width, height } = props;
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99999 2L8.0083 6L9.99999 10L14.2368 8.57991L15.6569 4.34313C14.2091 2.89544 12.2091 2 9.99999 2V2Z"
        fill="#FFE278"
      />
      <path
        d="M9.99998 2C7.95261 2 5.90523 2.78106 4.34314 4.34316L5.76323 8.57994L9.99998 10V2Z"
        fill="#B0D16F"
      />
      <path
        d="M4.34316 4.34326C2.89544 5.79098 2 7.79098 2 10.0001L6 11.9918L10 10.0001L4.34316 4.34326Z"
        fill="#45C5FF"
      />
      <path
        d="M2 10C2 12.0474 2.78106 14.0948 4.34316 15.6568L8.57994 14.2367L10 10H2Z"
        fill="#0CA8ED"
      />
      <path
        d="M4.34314 15.6568C5.79086 17.1046 7.79086 18 9.99998 18L11.9917 14L9.99998 10L4.34314 15.6568Z"
        fill="#1365C2"
      />
      <path
        d="M10 18C12.0474 18 14.0948 17.219 15.6568 15.6568L14.2367 11.4201L10 10V18Z"
        fill="#F71E78"
      />
      <path
        d="M15.6568 15.6568C17.1046 14.2091 18 12.2091 18 9.99999L14 8.0083L10 9.99999L15.6568 15.6568Z"
        fill="#FF776B"
      />
      <path
        d="M15.6568 4.34326L10 10.0001H18C18 7.95273 17.2189 5.90536 15.6568 4.34326Z"
        fill="#FFB54C"
      />
    </svg>
  );
};

export default SvgBackground;
